import React, { FunctionComponent } from 'react';
import { css } from '@emotion/core';

import { Flex, Box, Image } from '@rebass/emotion';
import {
  IMAGE_STYLE_SEAMLESS,
  IMAGE_STYLE_REGULAR,
  layoutWidth,
  flexContainerStyles,
  ImageWrapper,
} from './SeamlessElement2Col.style';
import { SeamlessElementsQuery_seamlessSection_elements_SeamlessElement2Col as SeamlessElement2ColProps } from '../SeamlessSection/__generated__/SeamlessElementsQuery';

const SeamlessElement2Col: FunctionComponent<SeamlessElement2ColProps> = ({
  content,
  image,
  imageStyle,
  contentPosition,
  background,
}) => {
  const isImageRegular = image && imageStyle === IMAGE_STYLE_REGULAR;
  const isImageSeamLess = image && imageStyle === IMAGE_STYLE_SEAMLESS;

  return (
    <Box
      data-testid="seamless-element-2col"
      py={isImageRegular ? 4 : 0}
      css={css`
        position: relative;
        line-height: 0;
        background-color: ${background};
      `}
    >
      <Flex
        css={flexContainerStyles({
          imageStyle,
          contentPosition,
        })}
        p={[4, 3]}
        width={layoutWidth}
      >
        {content && (
          <Box
            px={[0, 4]}
            width={['100%', '50%']}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
        {isImageRegular && (
          <ImageWrapper width={[1, 1 / 2]}>
            <Image src={image} width={1} />
          </ImageWrapper>
        )}
      </Flex>
      {isImageSeamLess && <Image src={image} />}
    </Box>
  );
};

export default SeamlessElement2Col;
